export default __webpack_public_path__ + "static/media/me-new-dark-text.53e59895.png";